import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class ClassGroupRoute extends Route 
{
	@service store;
	
	//preload all the intermediate timing points for each course elment for the course for this classgroup
	model(params) 
	{
		var event = this.modelFor('event');
		var classGroup = null;
		
		return this.store.findRecord('ClassGroup', params.classGroup_id).then(function(cGroup)
		{
			classGroup = cGroup;
			return cGroup.get('CourseId');
		}).then(function(course)
		{
			return course.get('courseElements');
		}).then(function(courseElements)
		{
			return courseElements.map(function(courseElement)
			{
				return courseElement.get('IntermediateTimingPointId');
			});
		}).then(function()
		{
			return {
				event: event,
				classGroup: classGroup
			};
		});
	}
}